import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;

  input {
    margin-left: 1em;
    width: 16em;
  }
`;
